import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RouteNamesEnum } from '@citizen/routes/routes';
import { GridAuditRecordService } from '@shared/services/audit-service/grid-audit-record.service';
import { ExportExcelService } from '@citizen/services/data-grid-service/export-excel-service/export-excel.service';
import { GridTypeEnum, gridTableheadersMap } from '@shared/utils/mappers/grid-mapper';
import { IAuditComponent, IAuditModel, IAuditGridModel, fileNameAuditDownloaded } from '@shared/models/audit.model';
import { Breadcrumb } from '@types-custom/models/ui/breadcrumb-model';
import { GridPageActions, IGridPageModel } from '@types-custom/models/ui/grid-page-model';
import { IGridTableCellDispatcher } from '@types-custom/models/ui/grid-table-model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { Subject } from 'rxjs';

@Component({
  selector: 'grid-audit-record',
  templateUrl: './grid-audit-record.component.html',
  styleUrls: ['./grid-audit-record.component.scss'],
})
export class GridAuditRecordComponent  implements OnInit {

  @Input() model: IAuditModel;
  @Output() handleValue = new EventEmitter<any>();

  Icon = Icon;
  icon = Icon.manage_accounts_w;
  layerName = GridTypeEnum.ManageGridRecordAudit;
  editColumnDispatcher = new Subject<IGridTableCellDispatcher>();
  isAllowDownload = true;
  breadcrumbs: Breadcrumb[];
  gridPageProps: IGridPageModel = {
    headers: gridTableheadersMap([this.editColumnDispatcher])[this.layerName],
    dataSource: this.gridAuditRecordService,
    isAllowDownloadExcel: this.isAllowDownload,
    isAllowDownloadPdf: false,
    dispatcher: this.editColumnDispatcher
  };

  constructor(
    private router: Router,
    public gridAuditRecordService: GridAuditRecordService,
    private exportExcelService: ExportExcelService,
  ) {
    this.gridAuditRecordService.init();
    this.editColumnDispatcher.subscribe(this.handleClick.bind(this));
  }

  ngOnInit(): void {
    this.breadcrumbs = this.model.routes;
    if(this.breadcrumbs.length == 1) {
      this.breadcrumbs.push({
        label: this.model?.data?.name,
        url: IAuditComponent.GRID_AUDIT_RECORD
      });
    }
  }

  public handleClick(columnAction: IGridTableCellDispatcher): void {
    const auditGrid: IAuditGridModel = columnAction.row;
    // CONSUMIR EL SERVICIO PARA OBTENER LA DATA DE LA AUDITORIA SELECCIONADA
    this.gridAuditRecordService
      .getDataSelected(this.model.code, auditGrid.id, auditGrid.revId)
      .subscribe({
        next: (data: Array<any>) => {
          const modelAudit: IAuditModel = {
            code: this.model.code,
            renderAuditPanel: true,
            data: auditGrid,
            dataAux: data,
            routes: this.model.routes
          };
          this.handleValue.emit(modelAudit);
        },
      });
  }

  navigateToVisor(): void {
    this.router.navigate([RouteNamesEnum.MapViewer]);
  }

  navigateToPrincipal(component: string): void {
    if(component == IAuditComponent.PRINCIPAL) {
      const modelAudit: IAuditModel = {
        code: this.model.code,
        renderGridUser: false,
        renderPrincipal: true
      };
      this.handleValue.emit(modelAudit);
    }
  }

  handleDownloadGridAction(fileType: GridPageActions): void {
    const fileProps = {
      url: this.gridAuditRecordService.buildExcelUrl(this.model.code, this.model.data.id),
    };
    this.exportExcelService.downloadFile(
      fileProps.url,
      fileNameAuditDownloaded[this.layerName],
      fileType as unknown as string
    );
  }
}
